/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

export type InvoicesListTypeItem = typeof InvoicesListTypeItem[keyof typeof InvoicesListTypeItem];


export const InvoicesListTypeItem = {
  callback: 'callback',
  fee: 'fee',
  inspection: 'inspection',
  maintenance: 'maintenance',
  modernization: 'modernization',
  repair: 'repair',
} as const;
